import type { EdgeTypes, NodeTypes } from '@xyflow/react';
import type { ReactNode } from 'react';
import { ColumnEdge } from '../ColumnEdge/ColumnEdge';
import { TableEdge } from '../TableEdge/TableEdge';
import TableNode from '../TableNode/TableNode';
export interface ERDFlowProps {
	children?: ReactNode;
}

export const nodeTypes: NodeTypes = {
	TABLE: TableNode,
};

export const edgeTypes: EdgeTypes = {
	TABLE: TableEdge,
	COLUMN: ColumnEdge,
};
